import { PMNModele } from '@/domain/PMNModele'

export class PMNModeleAdmin extends PMNModele {
    visibleDentaire = false
    visibleDOMTOM = false
    visibleMaxilo = false
    visibleOrtho = false
    numeroQualite = ''
    produitsProposes = [] as ProduitProposePMNDTO[]
    listeModelesFichiers = [] as string[]
}

export class ProduitProposePMNDTO{
    id = 0
    nom = ''
    codeArticle = ''
    prix = 0
    LPPR = ''
    codeFamille = ''
    libelleFamille = ''
}